import React from "react";
import { BsArrowClockwise } from "react-icons/bs";

export const PageLoadError = ({
  errorMessage,
  containerStyle,
  showRefreshButton = true,
}) => {
  return (
    <div
      // style={{
      //   position: "absolute",
      //   top: "0",
      //   left: "0",
      //   right: "0",
      //   bottom: "0",
      //   display: "grid",
      //   placeContent: "center",
      //   textAlign: "center",
      // }}
      style={
        containerStyle ?? {
          //if a containerStyle is passed in, use it, otherwise use the default style below.
          paddingTop: "300px",
          paddingBottom: "300px",
          textAlign: "center",
        }
      }
    >
      {errorMessage ?? //if a errorMessage is passed in, use it, otherwise use the defualt message below.
        "There was an issue processing your request. Please try refreshing the page."}
      {showRefreshButton && (
        <>
          <br />
          <button
            type="button"
            onClick={() => {
              window.location.reload();
            }}
            style={{
              outline: "none",
              border: "none",
              margin: "10px",
              backgroundColor: "transparent",
              fontSize: "1.5rem",
            }}
          >
            <BsArrowClockwise alt="Refresh" title="Refresh" />
          </button>
        </>
      )}
    </div>
  );
};
